import { ADD_ASSET, DELETE_ASSET, DELETE_ALL_ASSETS } from '../actions'

// Holds names of assets alongside their location on the server so we can display them
export default (assets = {}, action) => {
  switch (action.type) {
    case ADD_ASSET: 
      return {
        ...assets, 
        [action.payload.filename]: action.payload.data
      };
    case DELETE_ASSET: 
      let newAssets = {...assets};
      delete newAssets[action.payload.filename];
      return newAssets;
    case DELETE_ALL_ASSETS: 
      return {}
    default:
      return assets;
  }
 
}